import { withI18n } from 'react-i18next';
import { LocationsButton } from './LocationsButton';
export default withI18n()(LocationsButton);
